import React from 'react';

const Loader: React.FC = () => {
  return (
    <>
      <div className="loader">
        <div className="animated-arrow--1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 446 379" fill="none">
            <path
              fill="#7A2426"
              d="M147.26.371c143.636.791 296.219 262.008 296.219 378.451V.372H147.26Z"
            />
          </svg>
        </div>
        <div className="animated-arrow--2">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 446 379" fill="none">
            <path
              fill="#7A2426"
              d="M147.26.371c143.636.791 296.219 262.008 296.219 378.451V.372H147.26Z"
            />
          </svg>
        </div>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 446 379" fill="none">
            <path
              fill="#000"
              d="M308.616 346.106c-19.505-12.087-41.116-30.219-65.017-72.709-15.292-27.105-34.156-63.551-42.673-79.393 31.318-14.835 78.478-46.062 78.478-98.9 0-6.226-.458-11.904-1.282-17.398C268.599 8.752 201.659.876 151.752.602H.839v12.545l20.421 1.74c22.161 2.29 22.161 5.128 22.161 74.449v197.706c0 69.229 0 72.068-22.16 74.357L.84 363.139v12.545h137.634v-12.545l-20.421-1.74c-21.611-2.289-21.611-5.128-21.611-74.357v-74.907h21.061c11.905 0 26.19 0 35.256 7.417 7.417 6.227 20.512 27.839 35.256 55.585l22.71 43.68c17.032 31.227 43.222 56.867 80.767 56.867h153.934c-5.861-.549-111.444-13.919-136.718-29.578h-.092ZM128.767 196.201H96.35V23.953c11.355-2.29 23.351-4.579 35.256-4.579 44.321 0 88.093 20.42 88.093 86.994s-43.223 89.833-90.932 89.833Z"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Loader;
